module.exports = __webpack_public_path__ + "static/media/inprogress.9a9fe89c.png";